// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Box/Box.css */
.box {
  background-color: white;
  border-radius: 10px;
  border: 1px solid #bdc3c7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: visible;
  z-index: 1;
}

.sidebar .box {
  margin: 10px 0;
  height: 80px;
  width: calc(100% - 20px);
}

.lane .box {
  margin: 0 10px;
  height: 120px;
  width: calc(100% / 4 - 20px);
}

.box-header {
  width: 100%;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  z-index: 2;
}

.box-header-subbands {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.subband {
  height: 100%;
}

.box-content {
  padding: 10px;
  margin-top: 20px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-content-centered {
  text-align: center;
  width: 100%;
}

/* Action buttons in top-right corner */
.box-actions {
  position: absolute;
  top: 14px;
  right: 6px;
  display: flex;
  gap: 4px;
  z-index: 10;
}

.box-actions button {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
  opacity: 0.6;
}

.box:hover .box-actions button {
  opacity: 1;
}

.edit-box-btn {
  background: #EBF5FF;
  color: #3B82F6;
}

.edit-box-btn:hover {
  background: #3B82F6;
  color: white;
}

a.open-tab-btn {
  background: #FEF3C7;
  color: #D97706;
  text-decoration: none;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
  opacity: 0.6;
}

.box:hover a.open-tab-btn {
  opacity: 1;
}

a.open-tab-btn:hover {
  background: #D97706;
  color: white;
}

.remove-box-btn {
  background: #FEE2E2;
  color: #DC2626;
  font-size: 18px;
}

.remove-box-btn:hover {
  background: #DC2626;
  color: white;
}

/* Legacy - keep for backwards compatibility */
.remove-box {
  display: none;
}

.box-selected {
  border: 2px solid blue;
  outline: none;
  box-shadow: 0 0 10px blue;
}

.box,
.box * {
  -webkit-user-select: none;
          user-select: none;
}

.box-content h3 {
  margin: 0;
  padding: 5px 0;
}

.box-content .box-title {
  font-size: 14px;
  font-weight: 600;
  color: #2C3E50;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-content .box-subtitle {
  font-size: 11px;
  color: #7F8C8D;
  margin: 0;
}

.box-content p {
  margin: 5px 0;
}

/* Primary person star button */
.primary-star-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px 0 0;
  vertical-align: middle;
  opacity: 0.4;
  transition: all 0.2s ease;
}

.primary-star-btn:hover {
  opacity: 1;
  transform: scale(1.2);
}

.primary-star-btn.is-primary {
  opacity: 1;
  color: #F59E0B;
}

/* Highlight box when primary */
.box.is-primary-person {
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.3), 0 2px 5px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Box/Box.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,2EAA2E;AAC7E","sourcesContent":["/* src/components/Box/Box.css */\n.box {\n  background-color: white;\n  border-radius: 10px;\n  border: 1px solid #bdc3c7;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: visible;\n  z-index: 1;\n}\n\n.sidebar .box {\n  margin: 10px 0;\n  height: 80px;\n  width: calc(100% - 20px);\n}\n\n.lane .box {\n  margin: 0 10px;\n  height: 120px;\n  width: calc(100% / 4 - 20px);\n}\n\n.box-header {\n  width: 100%;\n  height: 10px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  z-index: 2;\n}\n\n.box-header-subbands {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  overflow: hidden;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.subband {\n  height: 100%;\n}\n\n.box-content {\n  padding: 10px;\n  margin-top: 20px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.box-content-centered {\n  text-align: center;\n  width: 100%;\n}\n\n/* Action buttons in top-right corner */\n.box-actions {\n  position: absolute;\n  top: 14px;\n  right: 6px;\n  display: flex;\n  gap: 4px;\n  z-index: 10;\n}\n\n.box-actions button {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.15s ease;\n  opacity: 0.6;\n}\n\n.box:hover .box-actions button {\n  opacity: 1;\n}\n\n.edit-box-btn {\n  background: #EBF5FF;\n  color: #3B82F6;\n}\n\n.edit-box-btn:hover {\n  background: #3B82F6;\n  color: white;\n}\n\na.open-tab-btn {\n  background: #FEF3C7;\n  color: #D97706;\n  text-decoration: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.15s ease;\n  opacity: 0.6;\n}\n\n.box:hover a.open-tab-btn {\n  opacity: 1;\n}\n\na.open-tab-btn:hover {\n  background: #D97706;\n  color: white;\n}\n\n.remove-box-btn {\n  background: #FEE2E2;\n  color: #DC2626;\n  font-size: 18px;\n}\n\n.remove-box-btn:hover {\n  background: #DC2626;\n  color: white;\n}\n\n/* Legacy - keep for backwards compatibility */\n.remove-box {\n  display: none;\n}\n\n.box-selected {\n  border: 2px solid blue;\n  outline: none;\n  box-shadow: 0 0 10px blue;\n}\n\n.box,\n.box * {\n  user-select: none;\n}\n\n.box-content h3 {\n  margin: 0;\n  padding: 5px 0;\n}\n\n.box-content .box-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2C3E50;\n  margin: 0 0 4px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.box-content .box-subtitle {\n  font-size: 11px;\n  color: #7F8C8D;\n  margin: 0;\n}\n\n.box-content p {\n  margin: 5px 0;\n}\n\n/* Primary person star button */\n.primary-star-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 4px 0 0;\n  vertical-align: middle;\n  opacity: 0.4;\n  transition: all 0.2s ease;\n}\n\n.primary-star-btn:hover {\n  opacity: 1;\n  transform: scale(1.2);\n}\n\n.primary-star-btn.is-primary {\n  opacity: 1;\n  color: #F59E0B;\n}\n\n/* Highlight box when primary */\n.box.is-primary-person {\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.3), 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
